import { Routes, Route } from 'react-router-dom';

import CardWrapper from '../../../features/automatedEmailCampaignSettings/childRoutes/CardWrapper';
import { JobAutomationListing } from '../features';

export const AutomationChildRoutes = () => (
  <Routes>
    <Route
      path="/automation-settings"
      element={
        <CardWrapper>
          <JobAutomationListing title={''} />
        </CardWrapper>
      }
    />
    <Route
      path="/candidates"
      element={
        <CardWrapper>
          <JobAutomationListing title={'Candidate Automations'} />
        </CardWrapper>
      }
    />
    <Route
      path="/submissions"
      element={
        <CardWrapper>
          <JobAutomationListing title={'Submission Automations'} />
        </CardWrapper>
      }
    />
  </Routes>
);
